export const environment = {
  production: false,
  version_apk: '0.0.39',
  api_key: '4H5gt8Zn6p1PLwxMcIaRa9YayKQzWVFk',
  empresa: 'g2k',
  wsBaseUrl: 'https://controltiempo.g2k.es:8443/Marcajes/ControladorMarcajes',
  wsBaseUrlRaiz: 'https://controltiempo.g2k.es:8443/Marcajes',
  // wsBaseUrl: 'http://192.168.1.48:8080/Marcajes/ControladorMarcajes',
  // wsBaseUrlRaiz: 'http://192.168.1.48:8080/Marcajes',
  // wsBaseUrl: 'https://ssl.ctgbn.es:8443/Marcajes/ControladorMarcajes',
  // wsBaseUrlRaiz: 'https://ssl.ctgbn.es:8443/Marcajes',
  // wsBaseUrl: 'http://localhost:8080/Marcajes/ControladorMarcajes',
  // wsBaseUrlRaiz: 'http://localhost:8080/Marcajes',
  /**
   * Ruta base del servidor alternativo node.
   */
  rutaAltWS: 'https://node.g2k.es:1460',
  // rutaAltWS: 'http://192.168.1.25:1460',
  // rutaAltWS: 'http://localhost:1460',
  personalizado: {
    tituloWeb: 'G2kMarcajes',
    codigoColor: 'primary',
    enlaceAyuda: 'https://www.g2k.es/ct',
    enlaceFavicon: 'assets/icon/favicon.png',
    colorTema: '#1976d2',
    logout: false,
    manifest: {
      "name": "G2kMarcajes",
      "short_name": "G2kMarcajes",
      "theme_color": "#1976d2",
      "background_color": "#fafafa",
      "display": "standalone",
      "scope": "/",
      "start_url": "/",
      "orientation": "portrait",
      "icons": [
        {
          "src": "assets/icons/icon-72x72.png",
          "sizes": "72x72",
          "type": "image/png"
        },
        {
          "src": "assets/icons/icon-96x96.png",
          "sizes": "96x96",
          "type": "image/png"
        },
        {
          "src": "assets/icons/icon-128x128.png",
          "sizes": "128x128",
          "type": "image/png"
        },
        {
          "src": "assets/icons/icon-144x144.png",
          "sizes": "144x144",
          "type": "image/png"
        },
        {
          "src": "assets/icons/icon-152x152.png",
          "sizes": "152x152",
          "type": "image/png"
        },
        {
          "src": "assets/icons/icon-192x192.png",
          "sizes": "192x192",
          "type": "image/png"
        },
        {
          "src": "assets/icons/icon-384x384.png",
          "sizes": "384x384",
          "type": "image/png"
        },
        {
          "src": "assets/icons/icon-512x512.png",
          "sizes": "512x512",
          "type": "image/png"
        }
      ]
    },
  },
};
